/**
 * WP-M's preference screen — NT2 at `/account/notifications`.
 *
 * The route path is under `/account` and the directory is not: WP-D owns
 * `apps/web/src/routes/account/**` and has already built F1–F6 there. Exported as its
 * own `RouteObject[]` so the router mounts it alongside `accountRoutes` without either
 * package writing the other's files.
 */
import type { RouteObject } from 'react-router-dom';
import { NT2Preferences } from './NT2Preferences.js';

export const accountNotificationRoutes: RouteObject[] = [
  { path: '/account/notifications', element: <NT2Preferences /> },
];

export { NT2Preferences, NT2PreferencesView } from './NT2Preferences.js';
// `./data.js` is gone, for the reason `../notifications/routes.tsx` gives: NT2 renders
// `GET /v1/notifications/prefs`, which carries its chrome, its six drawn rows and the
// quiet-hours switch.
